export default __webpack_public_path__ + "static/media/graph.bab4200e.svg";